import { render, staticRenderFns } from "./advanced_search_home_v2.vue?vue&type=template&id=63c8acf8"
import script from "./advanced_search_home_v2.vue?vue&type=script&lang=js"
export * from "./advanced_search_home_v2.vue?vue&type=script&lang=js"
import style0 from "./advanced_search_home_v2.vue?vue&type=style&index=0&id=63c8acf8&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1702/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c8acf8')) {
      api.createRecord('63c8acf8', component.options)
    } else {
      api.reload('63c8acf8', component.options)
    }
    module.hot.accept("./advanced_search_home_v2.vue?vue&type=template&id=63c8acf8", function () {
      api.rerender('63c8acf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/advanced_search/components/advanced_search_home_v2.vue"
export default component.exports